import React from 'react'
import Layout from '../../components/LayoutNew'
import { graphql, useStaticQuery } from 'gatsby'
import HomeSection3 from '../../containers/HomeSection3'
import ProductSection1 from '../../containers/ProductSection1'
import ProductSection2 from '../../containers/ProductSection2'
import ProductSection3 from '../../containers/ProductSection3'
import { Fragment } from 'react'
import Img from 'gatsby-image'

import './sale.scss'

const SalePage = () => {
  const pageColor = '#ED3737'
  const { sale0, sale1, sale2, sale3, logoList } = useStaticQuery(graphql`
    query {
      sale0: file(relativePath: { eq: "products/sale/sale-0.png" }) {
        childImageSharp {
          fluid(maxWidth: 552, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      sale1: file(relativePath: { eq: "products/sale/sale-1.png" }) {
        childImageSharp {
          fluid(maxWidth: 552, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      sale2: file(relativePath: { eq: "products/sale/sale-2.png" }) {
        id
        childImageSharp {
          fluid(maxWidth: 552, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      sale3: file(relativePath: { eq: "products/sale/sale-3.png" }) {
        childImageSharp {
          fluid(maxWidth: 700, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      logoList: allFile(
        filter: { relativeDirectory: { glob: "products/sale/logo" } }
        sort: { fields: name, order: ASC }
      ) {
        nodes {
          childImageSharp {
            fluid(maxWidth: 80, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  `)

  return (
    <Layout
      className="sale-page"
      headerBackground={pageColor}
      headerTheme="white"
    >
      <ProductSection1
        className="section-0"
        background={pageColor}
        title="全渠道赋能，主导本地生活新时代"
        subTitle="一站式电商服务，多场景智能优化，帮助商户全渠道引流沉淀顾客，增加营收"
        extra={
          <div className="section-0-extra">
            <Img
              fluid={sale0.childImageSharp.fluid}
              alt="全渠道赋能，主导本地生活新时代"
            />
          </div>
        }
      />
      <ProductSection2
        className="section-1"
        title="美团点评团购套餐旺销"
        subTitle="明确品牌定位，结合营销热点，打造爆款套餐，助力新店开业，老店提升。
      为商家造势，迅速吸引人气，形成集聚效应，粉丝沉淀二次营销全靠它"
        image={
          <div style={{ width: '552px' }}>
            <Img
              fluid={sale1.childImageSharp.fluid}
              alt="美团点评团购套餐旺销"
            />
          </div>
        }
      />
      <ProductSection2
        className="section-2"
        type="row-reverse"
        title="外卖平台套餐搭配技巧"
        subTitle="深度剖析品牌分类，规范统一平台类目数量、类目排序、SKU，提炼产品优势，测算套餐毛利空间，为产品定价提供优质决策。从曝光、进店、下单、留存四大维度共同发力，提升客户进店转化率"
        image={
          <div style={{ width: '552px' }}>
            <Img
              fluid={sale2.childImageSharp.fluid}
              alt="外卖平台套餐搭配技巧"
            />
          </div>
        }
      />
      {/* <ProductSection2
        className="section-3"
        type="column"
        title="抖音平台团购券销售引流"
        subTitle={
          <Fragment>
            <div>
              一碗 KOL
              效应为品牌聚集人气，基于沉浸式内容，利用算法精准分发，在用户的碎片化娱乐中创造需求，完成线上种草线下消费的体验，带动产品销量
            </div>
            <div className="labels">
              <span>百亿流量</span>
              <span>建立焦点</span>
              <span>快速传播</span>
            </div>
          </Fragment>
        }
        image={
          <div style={{ width: '700px' }}>
            <Img
              fluid={sale3.childImageSharp.fluid}
              alt="抖音平台团购券销售引流"
            />
          </div>
        }
      /> */}
      <ProductSection3
        className="section-4"
        type="column"
        title="超过30000+商户都信赖再惠"
        image={
          <Fragment>
            <div className="logo-list">
              {logoList.nodes.map((logo, index) => (
                <div key={index}>
                  <Img fluid={logo.childImageSharp.fluid} />
                </div>
              ))}
            </div>
          </Fragment>
        }
      />
      <HomeSection3 />
    </Layout>
  )
}

export default SalePage
